import React, { createContext, useContext, useState, useEffect } from "react";
import { getCurrentLanguage, setLanguage as setLanguageStorage } from "../utils/translations";

const LanguageContext = createContext({
  language: "sq",
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getCurrentLanguage());

  // Update language in both state and localStorage
  const setLanguage = (lang) => {
    if (lang === "sq" || lang === "en") {
      setLanguageStorage(lang);
      setLanguageState(lang);
      // Update HTML lang attribute
      if (typeof document !== "undefined") {
        document.documentElement.setAttribute("lang", lang);
      }
    }
  };

  // Initialize language on mount
  useEffect(() => {
    const currentLang = getCurrentLanguage();
    setLanguageState(currentLang);
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", currentLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

